export default __webpack_public_path__ + "static/media/28-2.feebc298.mp3";